"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Bucket_1 = __importDefault(require("../ua/Bucket"));
class SymmetricSecurityHeader {
    constructor(options) {
        var _a, _b;
        this.TokenId = (_b = (_a = options) === null || _a === void 0 ? void 0 : _a.TokenId, (_b !== null && _b !== void 0 ? _b : 0));
    }
    encode() {
        const bucket = new Bucket_1.default();
        bucket.writeUint32(this.TokenId);
        return bucket.bytes;
    }
    decode(b, position) {
        const bucket = new Bucket_1.default(b, position);
        this.TokenId = bucket.readUint32();
        return bucket.position;
    }
}
exports.default = SymmetricSecurityHeader;
